module.exports = __webpack_public_path__ + "img/banner-image-md.ac7a0520.webp";